// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3si8v","header":"PatientQuestionnaire_header__3Zp3w","info":"PatientQuestionnaire_info__1KcO7"};